import styles from "./VideojsPlayer.module.scss"

import React, { memo, useEffect, useRef, useState } from "react"

import { StreamingStatus, useSchedule } from "@shared/contexts"
import { playerService } from "@shared/services"

import { createVideoPlayer, CunstomVideoJsPlayer } from "live/modules"

const REPLAY_DELAY = 1000 * 15
const INIT_DELAY = 1000 * 7

function VideojsPlayer() {
  const playerRef = useRef<HTMLVideoElement>(null)
  const delayRef = useRef<number>(INIT_DELAY)
  const streamingStatusRef = useRef<StreamingStatus>("START")
  const { schedule } = useSchedule()

  const [player, setPlayer] = useState<CunstomVideoJsPlayer | undefined>()

  const streamingUrl = schedule?.mobileStreamingUrl
  const streamingStatus = schedule?.streamingStatus

  useEffect(() => {
    if (!playerRef.current || player) return

    setPlayer(createVideoPlayer(playerRef.current))
  }, [streamingStatus, player])

  useEffect(() => {
    if (!player || !streamingUrl || !streamingStatus) return

    streamingStatusRef.current = streamingStatus

    if ((["END", "WAITING"] as StreamingStatus[]).includes(streamingStatus)) {
      player.reset()
      return
    }
    setTimeout(() => {
      ;(async () => {
        player.reset()
        if (
          (["END", "WAITING"] as StreamingStatus[]).includes(
            streamingStatusRef.current,
          )
        ) {
          return
        }
        player.src(await playerService.getStreamingUrl(streamingUrl, "LIVE"))
        player.load()
        player.ready(() => {
          player.play()
        })
      })()
    }, delayRef.current)
    delayRef.current = REPLAY_DELAY
  }, [streamingUrl, streamingStatus, player])

  return (
    <div className={styles.player}>
      <div data-vjs-player>
        <video ref={playerRef} className="video-js"></video>
      </div>
    </div>
  )
}

export default memo(VideojsPlayer)
